import BaseDataObject from './BaseDataObject';

export default class JockeyTrainerStart extends BaseDataObject {
  getLegNr() {
    return this.getInteger('legNr');
  }
  setLegNr(v) {
    return this.setInteger('legNr', v);
  }

  getStartNr() {
    return this.getInteger('startNr');
  }
  setStartNr(v) {
    return this.setInteger('startNr', v);
  }
}
